
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getDepartmentList = createAsyncThunk('/thunk/get-department', async () => {
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/app/v1/get-department`,{page:1})
        console.log("res",response)
        return response
    } catch (error) {
        throw error
    }});

